import React, { useEffect, useState } from "react";
import {
    BackNextButton, Select,
} from "../../../../../common";
import "react-datepicker/dist/react-datepicker.css";
import manualDetails from "../../../../../../assets/images/manualDetails.png";
import uploadDoc from "../../../../../../assets/images/uploadDoc.png";
import uploadCsv from "../../../../../../assets/images/uploadCSV.png";
import graphs from "../../../../../../assets/images/graphs.png";
import { useSelector } from "react-redux";
import { convertLetterCase, isDateGreaterThanProvidedYearsAgo } from "../../../../../../utils/Helper";
import { FinancialDocuments } from "./FinancialDocuments";
import LockedImage from '../../../../../../assets/icons/locked.png'
import { UploadDocuments } from "./UploadDocument";
import { currencyDetails } from "../../../../../../utils/currency";
import { currencyUnitDetails } from "../../../../../../utils/CurrencyUnits";
import { useGetCompanyFinanceChartDataMutation, useUpdateFinanceCurrencyMutation } from "../../../../../../store/Company/companyApiSlice";
import FinancialCharts from "../../../../../common/FinancialCharts";
import FillCompanyData from "./FillCompanyData";

export const FinancialSetup = ({ onPrev, onNext, onSkip }) => {
    const { currentEditingCompany } = useSelector((state) => state.company);
    const { token, userInfo } = useSelector((state) => state.auth);
    const getSelectedObject = JSON.parse(localStorage.getItem('selectedObject'))
    const [selectedIndex, setSelectedIndex] = useState(getSelectedObject?.selectedIndex ?? "");
    const [hideSetup, setHideSetup] = useState(getSelectedObject?.hideSetup ?? false);
    const [updateFinanceCurrency] = useUpdateFinanceCurrencyMutation();
    const [resData, setResData] = useState([]);
    const [currencyUnit, setCurrencyUnit] = useState({
        currency: "",
        units: "",
    });
    const [showWarning, setShowWarning] = useState(false);
    const [showUploadInput, setShowUploadInput] = useState(false);
    const [fetchGraphData, setFetchGraphData] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [isGraphdataAvailable, setIsGraphDataAvailable] = useState(false);
    const [getCompanyFinanceChartData] = useGetCompanyFinanceChartDataMutation();
    const handlePrev = () => {
        onPrev(2, "Auditor Information", "Financial");
    }
    const result = currentEditingCompany?.date_of_establishment ? isDateGreaterThanProvidedYearsAgo(currentEditingCompany?.date_of_establishment, 3) : false;
    const handleSubmit = async (e) => {
        e.preventDefault();
        onNext(0, "MOA", "Upload Document");
    };

    const handalBack = () => {
        localStorage.removeItem("selectedObject");
        setHideSetup(false)
    }

    const handleCurrencyUnit = (e) => {
        setCurrencyUnit({ ...currencyUnit, [e.target.name]: e.target.value })
    };

    const sections = [
        {
            id: 1,
            image: manualDetails,
            title: "Enter Information Manually",
            description: "Enter all of your details manually from your records",
            disabled: false
        },
        {
            id: 2,
            image: uploadDoc,
            title: "Upload Documents",
            description: "Request TREVEX to fill the details on your behalf",
            disabled: false
        },
        {
            id: 3,
            image: uploadCsv,
            title: "Upload CSV File",
            description: "Download our csv template and fill in the fields",
            disabled: false
        },
        {
            id: 4,
            image: graphs,
            title: "Financials Graphs",
            description: "Explore financial trends with interactive graphs.",
            disabled: false
        },
    ];

    const renderSections = () => {
        return sections.map((section, index) => {
            if (section.id === 4 && !isGraphdataAvailable) {
                return null;  // Skip rendering for section with id 4 if isGraphdata is not available
            }
            return (<div className={`relative w-[265px] ${(section?.disabled || !result) ? "cursor-not-allowed" : "cursor-pointer"}`}>
                <div key={index} onClick={() => { setSelectedIndex(section?.id) }} className={`w-full p-3 rounded-[8px] text-left font-normal cursor-pointer ${selectedIndex === section?.id ? "border-2 border-black" : "border"} ${(section?.disabled || !result) && "blur cursor-not-allowed"}`}>
                    <img src={section.image} className="w-full h-[180px] mb-2 rounded-[3px]" alt={section.title} />
                    <p className="text-[16px] leading-[24px] mb-1">{section.title}</p>
                    <p className="text-[14px] leading-[21px]">{section.description}</p>
                </div>
                {(section?.disabled || !result) && <div className="text-center flex flex-col items-center absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 shadow-inner-2xl rounded-lg p-4 w-full">
                    <img
                        src={LockedImage}
                        className="w-1/4 mx-auto mb-3"
                        alt="Credit Notice"
                    />
                    <h3 className="text-secondarytwo text-left text-f16 font-semibold mb-2 text-center">
                        {section.disabled ? "Coming Soon" : `${section.title} is not available`}
                    </h3>
                    <p className="text-secondary text-f12 mb-3 w-3/4 text-justify">
                        {section?.disabled ? "Stay tuned for tailor-made solutions, offering advanced features and seamless integration for enterprises!" : `${currentEditingCompany?.registered_company_name} is less than 3 years in business. Hence you do not have this option active.`}
                    </p>
                </div>}
            </div>)
        });
    };

    useEffect(() => {
        renderSections();
    }, [selectedIndex])
    const getGraphData = async () => {
        const resGraphData = await getCompanyFinanceChartData({ token: token, company_id: currentEditingCompany?.companyID , location:'dashboard'}).unwrap();
        const revenueProfitData = resGraphData?.profitability?.revenue_to_earnings_graph?.data ?? [];
        const roeRoaChartData = resGraphData?.profitability?.roe_to_roa?.data ?? [];
        const quickAssetsToLiabilities = resGraphData?.liquidity?.quick_assets_to_liabilities?.data ?? [];
        const operatingCashFlowRatio = resGraphData?.liquidity?.operating_cash_flow_ratio?.data ?? [];
        const freeCashFlowRatio = resGraphData?.liquidity?.free_cash_flow_ratio?.data ?? [];
        const cashConversionCycleRatio = resGraphData?.efficiency?.cash_conversion_cycle?.data ?? [];
        const efficiencyRatio = resGraphData?.efficiency?.efficiency_ratios?.data ?? [];
        const keyFinancials = resGraphData?.financial ?? [];
        (revenueProfitData?.length > 0 || roeRoaChartData?.length > 0 || quickAssetsToLiabilities?.length > 0 || operatingCashFlowRatio?.length > 0 || freeCashFlowRatio?.length > 0 || cashConversionCycleRatio?.length > 0 || efficiencyRatio?.length > 0 || keyFinancials?.length > 0) ? setIsGraphDataAvailable(true) : setIsGraphDataAvailable(false);
        currencyUnit.currency = resGraphData?.currency;
        currencyUnit.units = resGraphData?.units;
        setResData(resGraphData);
    }
    useEffect(() => {
        getGraphData()
    }, []);

    const onProceed = async () => {
        localStorage.setItem('selectedObject', JSON.stringify({ "hideSetup": true, "selectedIndex": selectedIndex }))
        const response = !resData?.is_currency_verified && await updateFinanceCurrency({ data: currencyUnit, token: token, companyId: currentEditingCompany?.companyID });
        setHideSetup(true)
    }
    return (<>
        {!hideSetup && <div className="mt-5 w-full md:max-w-[95%] lg:max-w-[90%]">
            <h3 className="text-f20 font-semibold text-secondarytwo text-left mb-2 flex">
                Financial Setup
            </h3>
            <div className={`relative border p-4 mb-4`}>
                <div>
                    <p className="text-left mb-4 text-[14px] font-semibold">Select how you want to proceed</p>
                    <div className={`flex flex-wrap justify-start mb-5 gap-3`}>
                        {renderSections()}
                    </div>
                    <div className="flex flex-col gap-1">
                        <Select disable={resData?.is_currency_verified} name='currency' value={currencyUnit?.currency} onChange={handleCurrencyUnit} label={'Select your Currency :'}>
                            <option value="">Select your Currency</option>
                            {currencyDetails.map((currency) => <option value={currency?.name}>{currency?.cc}</option>)}
                        </Select>
                        <Select disable={resData?.is_currency_verified} name='units' value={currencyUnit?.units} onChange={handleCurrencyUnit} label={'Select your Amount Unit :'}>
                            <option value="">Select your Amount Unit</option>
                            {currencyUnitDetails.map((unit) => <option value={unit?.name}>{convertLetterCase(unit?.name, 'titlecase')}</option>)}
                        </Select>
                    </div>

                </div>
            </div>
            <BackNextButton
                onPrev={handlePrev}
                onNext={handleSubmit}
                onSkip={() => onSkip(0, "MOA", "Upload Document")}
                isLoading={false}
                disable={!result || (selectedIndex !== 4 && (currencyUnit?.currency === "" || !currencyUnit?.currency)) || (selectedIndex !== 4 && (currencyUnit?.units === "" || !currencyUnit?.units)) || typeof (selectedIndex) !== 'number'}
                proceed={true}
                onProceed={onProceed}
            />
        </div>}
        {hideSetup && <div>
            {
                selectedIndex === 1 ? <div className=""><FillCompanyData onPrev={handalBack} onNext={onNext} onSkip={onSkip}/></div> : selectedIndex === 2 ? <UploadDocuments onPrev={handalBack} onNext={onNext} onSkip={onSkip} /> : selectedIndex === 3 ? <FinancialDocuments onPrev={handalBack} onNext={onNext} onSkip={onSkip} fetchGraphData={fetchGraphData} setFetchGraphData={setFetchGraphData} showWarning={isGraphdataAvailable} resData={resData}/> : selectedIndex === 4 ? <FinancialDocuments onPrev={handalBack} onNext={onNext} onSkip={onSkip} onlyGraph={true} resData={resData} fetchGraphData={fetchGraphData} setFetchGraphData={setFetchGraphData} /> : null
            }
        </div>}
    </>
    );
};